import { render, staticRenderFns } from "./account-layout.vue?vue&type=template&id=c55ec66c"
import script from "./account-layout.ts?vue&type=script&lang=js&external"
export * from "./account-layout.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports